import { render, staticRenderFns } from "./page005.vue?vue&type=template&id=0f43abd7&scoped=true&"
import script from "./page005.vue?vue&type=script&lang=js&"
export * from "./page005.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43abd7",
  null
  
)

export default component.exports